import { WIDE_HEAD } from '../featureMockups/sheetData';

export const ISOMETRIC_COS = Math.sqrt(3) / 2;
export const ISOMETRIC_SIN = 0.525;

export const COLUMN_COUNT = WIDE_HEAD.length;
export const ROW_COUNT = 10;
export const CELL_WIDTH = 36;
export const CELL_HEIGHT = 18;
export const GRID_WIDTH = COLUMN_COUNT * CELL_WIDTH;
export const GRID_DEPTH = ROW_COUNT * CELL_HEIGHT;
export const SHEET_RADIUS = 6;

export function iso(x: number, y: number, z: number) {
  return { x: (x - y) * ISOMETRIC_COS, y: (x + y) * ISOMETRIC_SIN - z };
}
